import script from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"

import "./QandAWidget.vue?vue&type=style&index=0&id=6bd051e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd051e5"]])

export default __exports__